// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacto {
  background: white;
  color: #333;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #f0f0f0;
}

.contacto .container {
  flex: 1;
}

.contacto .section-title {
  color: #5B4B8A;
  margin-bottom: 40px;
}

.contacto-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  align-items: center;
  margin-bottom: 30px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.contacto-info h3 {
  font-size: 1.5em;
  margin-bottom: 25px;
  color: #333;
  font-weight: 600;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 18px;
}

.info-item .icon {
  font-size: 1.3em;
  display: none;
}

.info-item p {
  margin: 0;
  font-size: 0.95em;
  color: #666;
}

.contact-buttons {
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 30px;
  justify-content: center;
  flex-wrap: wrap;
}

.contact-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95em;
  transition: all 0.3s ease;
  color: white;
  border: 2px solid transparent;
}

.contact-btn span {
  font-size: 1.1em;
  display: none;
}

.contact-btn.whatsapp {
  background: #25D366;
}

.contact-btn.whatsapp:hover {
  background: #1fb854;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.25);
}

.contact-btn.gmail {
  background: #EA4335;
}

.contact-btn.gmail:hover {
  background: #d33426;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(234, 67, 53, 0.25);
}

.contact-btn.instagram {
  background: linear-gradient(135deg, #F58529 0%, #DD2A7B 50%, #8134AF 100%);
}

.contact-btn.instagram:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(221, 42, 123, 0.25);
}

.footer-bottom {
  border-top: 1px solid #e0e0e0;
  padding-top: 20px;
  margin-top: 30px;
  text-align: center;
}

.footer-bottom p {
  color: #999;
  margin: 0;
  font-size: 0.9em;
}

@media (max-width: 768px) {
  .contacto {
    padding: 40px 20px;
  }

  .contacto-info h3 {
    font-size: 1.3em;
  }

  .contact-buttons {
    flex-direction: column;
    gap: 10px;
  }

  .contact-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".contacto {\r\n  background: white;\r\n  color: #333;\r\n  padding: 60px 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-top: 1px solid #f0f0f0;\r\n}\r\n\r\n.contacto .container {\r\n  flex: 1;\r\n}\r\n\r\n.contacto .section-title {\r\n  color: #5B4B8A;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.contacto-wrapper {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 40px;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n  max-width: 400px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  text-align: center;\r\n}\r\n\r\n.contacto-info h3 {\r\n  font-size: 1.5em;\r\n  margin-bottom: 25px;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.info-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.info-item .icon {\r\n  font-size: 1.3em;\r\n  display: none;\r\n}\r\n\r\n.info-item p {\r\n  margin: 0;\r\n  font-size: 0.95em;\r\n  color: #666;\r\n}\r\n\r\n.contact-buttons {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 12px;\r\n  margin-top: 30px;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.contact-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 12px 24px;\r\n  border-radius: 6px;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  font-size: 0.95em;\r\n  transition: all 0.3s ease;\r\n  color: white;\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.contact-btn span {\r\n  font-size: 1.1em;\r\n  display: none;\r\n}\r\n\r\n.contact-btn.whatsapp {\r\n  background: #25D366;\r\n}\r\n\r\n.contact-btn.whatsapp:hover {\r\n  background: #1fb854;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.25);\r\n}\r\n\r\n.contact-btn.gmail {\r\n  background: #EA4335;\r\n}\r\n\r\n.contact-btn.gmail:hover {\r\n  background: #d33426;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(234, 67, 53, 0.25);\r\n}\r\n\r\n.contact-btn.instagram {\r\n  background: linear-gradient(135deg, #F58529 0%, #DD2A7B 50%, #8134AF 100%);\r\n}\r\n\r\n.contact-btn.instagram:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(221, 42, 123, 0.25);\r\n}\r\n\r\n.footer-bottom {\r\n  border-top: 1px solid #e0e0e0;\r\n  padding-top: 20px;\r\n  margin-top: 30px;\r\n  text-align: center;\r\n}\r\n\r\n.footer-bottom p {\r\n  color: #999;\r\n  margin: 0;\r\n  font-size: 0.9em;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .contacto {\r\n    padding: 40px 20px;\r\n  }\r\n\r\n  .contacto-info h3 {\r\n    font-size: 1.3em;\r\n  }\r\n\r\n  .contact-buttons {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .contact-btn {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
